/**
 *
 * PluginIcon
 *
 */

import React from 'react';
import Book from '@strapi/icons/Book';
const PluginIcon = () => /*#__PURE__*/React.createElement(Book, null);
export default PluginIcon;